import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { showError, showSuccess } from '../utils/alerts';
import { API_BASE_URL } from '../config';

const VerGastosPendientes = ({ id_company, token }) => {
    const [gastosPendientes, setGastosPendientes] = useState([]);
    const [loading, setLoading] = useState(false);
    // Cargar los gastos pendientes al cargar la página
    useEffect(() => {
        const fetchGastosPendientes = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/api/gastos-pendientes/${id_company}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setGastosPendientes(response.data);
            } catch (error) {
                console.error('Error al obtener los gastos pendientes:', error);
            }
        };

        fetchGastosPendientes();
    }, [id_company, token]);
    // Función para registrar los gastos en la tabla asientos_contables
    const handleRegistrarGastos = async () => {
        setLoading(true);
        try {
            await axios.post(
                `${API_BASE_URL}/api/registrar-gastos`,
                { id_company },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            showSuccess('Gastos registrados correctamente en asientos contables');
            setGastosPendientes(gastosPendientes.filter(gasto => gasto.registrado === false));
        } catch (error) {
            console.error('Error al registrar los gastos:', error);
            showError('Error al registrar los gastos provenientes desde imagenes');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h1>Gastos Pendientes</h1>
            <table>
                <thead>
                    <tr>
                        <th>Fecha</th>
                        <th>Total</th>
                        <th>IVA</th>
                        <th>Valor Neto</th>
                        <th>Folio</th>
                        <th>RUT</th>
                        <th>Artículos</th>
                    </tr>
                </thead>
                <tbody>
                    {gastosPendientes.map((gasto) => (
                        <tr key={gasto.id}>
                            <td>{new Date(gasto.fecha).toISOString().slice(0, 10)}</td> 
                            <td>{gasto.total}</td>
                            <td>{gasto.iva}</td>
                            <td>{gasto.neto}</td>
                            <td>{gasto.folio}</td>
                            <td>{gasto.rut}</td>
                            <td>{gasto.articulos}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <button onClick={handleRegistrarGastos} disabled={loading}>
                {loading ? 'Registrando...' : 'Registrar Gastos en Asientos Contables'}
            </button>
        </div>
    );
};

export default VerGastosPendientes;
